module.exports = __webpack_public_path__ + "static/media/nat-3.cc2b0543.jpg";